import { IElektroSamsvarserklaringEkomnettRapport } from "../reportSchemas/elektroSamsvarserklaringEkomnettSchema.js";

export const ELEKTRO_SAMSVARSERKLARING_EKOMNETT_INIT_DATA: IElektroSamsvarserklaringEkomnettRapport = {
  generellInfo: {
    utarbeidetAv: "",
    kontrollertAv: "",
    godkjentAv: "",
    dokumentNr: "",
    revisjonsNr: "",
  },
  oppdragsgiver: {
    navn: "",
    oppdragsnummer: "",
    kontaktperson: "",
    adresse: "",
    postboks: "",
    postNr: "",
    sted: "",
    telefon: "",
    email: "",
    kundenummer: "",
  },
  anleggsadresse: {
    navn: "",
    adresse: "",
    postNr: "",
    sted: "",
    husNr: "",
    husNrBokstav: "",
    boligMappeId: "",
  },
  kontaktperson: {
    eierBrukerAnnet: null,
    navn: "",
    telefon: "",
    email: "",
  },
  ordreopplysninger: {
    ordreNummer: "",
    startDato: "",
    avsluttetDato: "",
  },
  utarbeidetAv: {
    navn: "",
    kontaktPerson: "",
    adresse: "",
    postNr: "",
    sted: "",
    telefon: "",
    email: "",
    organisasjonsNr: "918 836 519",
    enaAutorisasjonsNr: "ENA-12212",
  },
  fravikFraAnvendteNormer: "",
  anleggsbeskrivelse: {
    typeAnlegg: null,
    utfoertIht: [{ lovverk: "NEK 700", utgave: "" }],
    arbeidsbeskrivelse: "",
  },
  generatedAt: "",
  generatedBy: "",
};
